// extracted by mini-css-extract-plugin
export default {"main-container":"App_main-container__d3JzE","adjusted-height":"App_adjusted-height__GN4f3"};